import styled from "styled-components";

export const FullScreenButtonEl = styled.button`
    font-size: 1em;
    display: flex;
    align-items: center;
    background-color: transparent;
    float: right;
    margin-top: 0.37em;
`;